(function () {
  var quickAddDialogCount = 0;

  function getShopRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function updateCartCounts(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    document.querySelectorAll('[data-sms-cart-count]').forEach(function (count) {
      count.textContent = String(cart.item_count);
      count.hidden = cart.item_count === 0;
      count.setAttribute('aria-label', cart.item_count + (cart.item_count === 1 ? ' item in cart' : ' items in cart'));
    });

    document.querySelectorAll('.smsHeaderCart').forEach(function (cartLink) {
      var count = cartLink.querySelector('[data-sms-cart-count]');
      if (count || cart.item_count === 0) return;

      count = document.createElement('b');
      count.dataset.smsCartCount = '';
      count.textContent = String(cart.item_count);
      count.setAttribute('aria-label', cart.item_count + (cart.item_count === 1 ? ' item in cart' : ' items in cart'));
      cartLink.insertBefore(count, cartLink.querySelector('span'));
    });
  }

  function readQuickAddVariants(button) {
    var card = button.closest('.product-card');
    var data = card && card.querySelector('[data-sms-quick-add-variants]');

    if (!data) return [];

    try {
      return JSON.parse(data.textContent).filter(function (variant) {
        return variant && variant.available && variant.id;
      });
    } catch (error) {
      return [];
    }
  }

  function initialize(root) {
    if (!root || root.dataset.smsInitialized === 'true') return;
    root.dataset.smsInitialized = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sms-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sms-hero-dot]'));
    var current = 0;
    var timer;
    var autoplay = root.dataset.heroAutoplay === 'true';
    var speed = Math.max(5000, Number(root.dataset.heroSpeed || 8) * 1000);

    function showSlide(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('active', slideIndex === current);
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('active', dotIndex === current);
        dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
      });
    }

    function restart() {
      window.clearInterval(timer);
      if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(function () { showSlide(current + 1); }, speed);
      }
    }

    var previous = root.querySelector('[data-sms-hero-prev]');
    var next = root.querySelector('[data-sms-hero-next]');
    if (previous) previous.addEventListener('click', function () { showSlide(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { showSlide(current + 1); restart(); });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { showSlide(index); restart(); });
    });
    showSlide(0);
    restart();

    var rooms = Array.prototype.slice.call(root.querySelectorAll('.floorplan .room'));
    function updateSetup() {
      var selected = rooms.filter(function (room) { return room.classList.contains('selected'); });
      var total = selected.reduce(function (sum, room) {
        return sum + Number(room.dataset.btu || 0);
      }, 0);
      var count = root.querySelector('[data-sms-room-count]');
      var capacity = root.querySelector('[data-sms-capacity-total]');
      if (count) count.textContent = selected.length;
      if (capacity) capacity.textContent = (total / 1000) + 'K BTU';
    }
    rooms.forEach(function (room) {
      room.setAttribute('aria-pressed', room.classList.contains('selected') ? 'true' : 'false');
      room.addEventListener('click', function () {
        room.classList.toggle('selected');
        room.setAttribute('aria-pressed', room.classList.contains('selected') ? 'true' : 'false');
        updateSetup();
      });
    });

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sms-product-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sms-featured-grid] .product-card'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var filter = tab.dataset.smsProductFilter;
        tabs.forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          card.hidden = (card.dataset.group || '').split(/\s+/).indexOf(filter) === -1;
        });
      });
    });

    var toast = root.querySelector('[data-sms-toast-output]');
    var toastTimer;

    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.dataset.smsToastOutput = '';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      root.appendChild(toast);
    }

    function showToast(message) {
      toast.textContent = message;
      toast.classList.add('show');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toast.classList.remove('show'); }, 3200);
    }

    root.querySelectorAll('[data-sms-toast]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        showToast(trigger.dataset.smsToast);
      });
    });

    var quickAddDialog;
    var quickAddHeading;
    var quickAddSelect;
    var quickAddStatus;
    var quickAddConfirm;
    var activeQuickAddButton;

    function closeQuickAddDialog() {
      if (!quickAddDialog) return;
      if (typeof quickAddDialog.close === 'function' && quickAddDialog.open) {
        quickAddDialog.close();
      } else {
        quickAddDialog.removeAttribute('open');
      }
    }

    function ensureQuickAddDialog() {
      if (quickAddDialog) return quickAddDialog;

      quickAddDialogCount += 1;
      quickAddDialog = document.createElement('dialog');
      quickAddDialog.className = 'smsQuickAddDialog';
      quickAddDialog.dataset.smsQuickAddDialog = '';

      var panel = document.createElement('div');
      panel.className = 'smsQuickAddPanel';

      var closeButton = document.createElement('button');
      closeButton.className = 'smsQuickAddClose';
      closeButton.type = 'button';
      closeButton.textContent = '×';
      closeButton.setAttribute('aria-label', 'Close quick add');
      closeButton.addEventListener('click', closeQuickAddDialog);

      var eyebrow = document.createElement('p');
      eyebrow.className = 'smsQuickAddEyebrow';
      eyebrow.textContent = 'Quick add';

      quickAddHeading = document.createElement('h2');
      quickAddHeading.id = 'SmsQuickAddHeading-' + quickAddDialogCount;
      quickAddDialog.setAttribute('aria-labelledby', quickAddHeading.id);

      var copy = document.createElement('p');
      copy.className = 'smsQuickAddCopy';
      copy.textContent = 'Choose an available configuration before adding this system to your cart.';

      var field = document.createElement('label');
      field.className = 'smsQuickAddField';

      var fieldLabel = document.createElement('span');
      fieldLabel.textContent = 'Available options';

      quickAddSelect = document.createElement('select');
      quickAddSelect.name = 'quick-add-variant';

      field.appendChild(fieldLabel);
      field.appendChild(quickAddSelect);

      quickAddStatus = document.createElement('p');
      quickAddStatus.className = 'smsQuickAddStatus';
      quickAddStatus.setAttribute('role', 'status');
      quickAddStatus.setAttribute('aria-live', 'polite');

      var actions = document.createElement('div');
      actions.className = 'smsQuickAddActions';

      var viewProduct = document.createElement('a');
      viewProduct.className = 'btn btn-outline';
      viewProduct.dataset.smsQuickAddProductLink = '';
      viewProduct.textContent = 'View product';

      quickAddConfirm = document.createElement('button');
      quickAddConfirm.className = 'btn btn-blue';
      quickAddConfirm.type = 'button';
      quickAddConfirm.textContent = 'Add to cart';

      actions.appendChild(viewProduct);
      actions.appendChild(quickAddConfirm);
      panel.appendChild(closeButton);
      panel.appendChild(eyebrow);
      panel.appendChild(quickAddHeading);
      panel.appendChild(copy);
      panel.appendChild(field);
      panel.appendChild(quickAddStatus);
      panel.appendChild(actions);
      quickAddDialog.appendChild(panel);
      root.appendChild(quickAddDialog);

      quickAddDialog.addEventListener('click', function (event) {
        if (event.target === quickAddDialog) closeQuickAddDialog();
      });

      quickAddDialog.addEventListener('close', function () {
        activeQuickAddButton = null;
        quickAddStatus.textContent = '';
      });

      quickAddConfirm.addEventListener('click', function () {
        var trigger = activeQuickAddButton;
        var variantId = quickAddSelect.value;

        if (!trigger || !variantId) return;

        quickAddConfirm.disabled = true;
        quickAddConfirm.textContent = 'Adding…';
        quickAddStatus.textContent = 'Adding your selected option to the cart.';

        addVariant(trigger, variantId).then(function (added) {
          quickAddConfirm.disabled = false;
          quickAddConfirm.textContent = 'Add to cart';
          quickAddStatus.textContent = added ? 'Added to cart.' : 'Please try again or view the product page.';
          if (added) closeQuickAddDialog();
        });
      });

      return quickAddDialog;
    }

    function setQuickAddButtonState(button, state) {
      var productTitle = button.dataset.productTitle || 'Product';

      if (!button.dataset.smsQuickAddLabel) {
        button.dataset.smsQuickAddLabel = button.textContent.trim() || '+';
      }

      button.classList.toggle('is-loading', state === 'loading');
      button.classList.toggle('is-added', state === 'added');
      button.disabled = state === 'loading';

      if (state === 'loading') {
        button.textContent = '';
        button.setAttribute('aria-label', 'Adding ' + productTitle + ' to cart');
      } else if (state === 'added') {
        button.textContent = '✓';
        button.setAttribute('aria-label', productTitle + ' added to cart');
      } else {
        button.textContent = button.dataset.smsQuickAddLabel;
        button.setAttribute('aria-label', 'Quick add ' + productTitle);
      }
    }

    function addVariant(button, variantId) {
      var productTitle = button.dataset.productTitle || 'Product';
      var numericVariantId = Number(variantId);

      if (!Number.isFinite(numericVariantId)) {
        showToast('This option could not be added. Please open the product page and try again.');
        return Promise.resolve(false);
      }

      setQuickAddButtonState(button, 'loading');

      return window.fetch(getShopRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: numericVariantId,
            quantity: 1
          }]
        })
      }).then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'This product could not be added to the cart.');
          }
          return payload;
        });
      }).then(function () {
        return window.fetch(getShopRoot() + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then(function (response) {
          return response.ok ? response.json() : null;
        }).catch(function () {
          return null;
        });
      }).then(function (cart) {
        updateCartCounts(cart);
        document.dispatchEvent(new CustomEvent('sms:cart-change', { detail: cart }));
        setQuickAddButtonState(button, 'added');
        showToast(productTitle + ' was added to your cart.');
        window.setTimeout(function () { setQuickAddButtonState(button, 'idle'); }, 1800);
        return true;
      }).catch(function (error) {
        setQuickAddButtonState(button, 'idle');
        showToast(error.message || 'This product could not be added to the cart.');
        return false;
      });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sms-quick-add]');
      if (!button || !root.contains(button) || button.disabled) return;

      event.preventDefault();

      var variants = readQuickAddVariants(button);
      if (!variants.length && button.dataset.variantId) {
        variants = [{
          id: button.dataset.variantId,
          title: 'Default option',
          available: true,
          price: ''
        }];
      }

      if (!variants.length) {
        showToast('This product is currently unavailable.');
        return;
      }

      if (variants.length === 1) {
        addVariant(button, variants[0].id);
        return;
      }

      var dialog = ensureQuickAddDialog();
      activeQuickAddButton = button;
      quickAddHeading.textContent = button.dataset.productTitle || 'Choose an option';
      quickAddSelect.replaceChildren();
      quickAddStatus.textContent = '';

      variants.forEach(function (variant) {
        var option = document.createElement('option');
        var title = variant.title === 'Default Title' ? 'Standard option' : variant.title;
        option.value = variant.id;
        option.textContent = variant.price ? title + ' — ' + variant.price : title;
        quickAddSelect.appendChild(option);
      });

      dialog.querySelector('[data-sms-quick-add-product-link]').href = button.dataset.productUrl;

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      quickAddSelect.focus();
    });
  }

  function initializeAll(scope) {
    if (scope && scope.matches && scope.matches('[data-sms-exact-homepage]')) initialize(scope);
    (scope || document).querySelectorAll('[data-sms-exact-homepage]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
}());
